import { addError } from 'dux/errors';
import Errors from 'dux/errors/errors';

export const downloadPdf = ( html, filename ) => {
    return ( dispatch, getState ) => {
        const state = getState(),
            body = JSON.stringify( { html } );

        return window.fetch( state.env.PDF_SERVICE_URL, {
                method: 'POST',
                body,
                headers: {
                    'Content-Type': 'application/json'
                }
            } )
            .then( response => response.blob() )
            .then( blob => {
                if ( window.navigator.msSaveOrOpenBlob ) {
                    window.navigator.msSaveOrOpenBlob( blob, filename );
                } else {
                    const objectURL = URL.createObjectURL( blob );
                    const link = document.createElement( 'a' );
                    link.style.display = 'none';
                    link.download = filename;
                    link.href = objectURL;
                    document.body.appendChild( link );
                    link.click( );
                    setTimeout( () => {
                        document.body.removeChild( link );
                        window.URL.revokeObjectURL( objectURL );
                    }, 100 );
                }
            } )
            .catch( ( error ) => {
                dispatch( addError( error, Errors.ERROR_EXPORT_RULES_FAILED ) );
            } );
    };
};
